import raw from './navigation.json';
import type { INavigationModel } from './INavigationModel';

/** Модель глобальної навігації v4: navigation.json генерує Tools/import_v4_navigation.py з констант прототипу (не редагувати вручну). */
export const navigationModel: INavigationModel = raw as INavigationModel;
